//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "AphasiaClassification_info",

}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Neuro/AphasiaClassification_info.vue